<template>
  <div>
    <div :class="[data.props.severity]" class="text">
      <table v-if="data.label" class="text-table">
        <tr>
          <td style="width: 200px">{{ data.label }}
            <footnotes v-if="data.props.footnotes" :all-footnotes="footnotes" :local-footnotes="data.props.footnotes"></footnotes>
          </td>
          <td>
            <p v-for="line in data.lines">
              {{ line.text }}
            </p>
          </td>
        </tr>
      </table>
      <p v-for="line in data.lines" v-else style="display:inline">
        {{ line.text }}
        <footnotes v-if="data.props.footnotes" :all-footnotes="footnotes" :local-footnotes="data.props.footnotes"></footnotes>
      </p>
    </div>
  </div>
</template>

<script>
import Footnotes
  from "./Footnotes.vue"

export default {
  name: 'TEXT',
  components: {Footnotes},
  props: ['data', 'footnotes'],
}
</script>

<style lang="scss">
.text.INFO {
  background-color: #d9edf7;
  color: #31708f;
  padding: 10px 14px;
  margin: 5px 0;
}
</style>




// WEBPACK FOOTER //
// TEXT.vue?3dafcfb5